import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  confirmSaasLink,
  fetchSaasLinks,
  rejectSaasLink,
  type LinksFilter,
} from '../lib/saas-links-api';

export const saasLinksKeys = {
  all: ['saas-links'] as const,
  list: (filter: LinksFilter) => [...saasLinksKeys.all, 'list', filter] as const,
};

export function useSaasLinks(filter: LinksFilter = {}) {
  return useQuery({
    queryKey: saasLinksKeys.list(filter),
    queryFn: () => fetchSaasLinks(filter),
    staleTime: 30_000,
  });
}

export function useConfirmSaasLink() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => confirmSaasLink(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: saasLinksKeys.all }),
  });
}

export function useRejectSaasLink() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, reason }: { id: string; reason?: string | null }) =>
      rejectSaasLink(id, reason),
    onSuccess: () => qc.invalidateQueries({ queryKey: saasLinksKeys.all }),
  });
}
